/* eslint-disable vue/require-default-prop */
<template>
  <v-card style="max-height:350px;">
    <v-list two-line>
      <v-list-tile
        v-if="notificacoes['users'] && notificacoes['users'].length > 0"
        avatar
        @click="openUser(notificacoes['users'].map(n => n.id))">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-account</v-icon>
        </v-list-tile-avatar>

        <template v-if="notificacoes['users'] && notificacoes['users'].length > 1">
          <v-list-tile-title
            v-text="String(strings[idioma].temos_x_usuarios).format(notificacoes['users'].length)"
          />
        </template>
        <template v-if="notificacoes['users'] && notificacoes['users'].length === 1">
          <v-list-tile-title
            v-text="String(strings[idioma].tem_um_usuario).format(notificacoes['users'].length)"
          />
        </template>
      </v-list-tile>
      <v-list-tile
        v-for="n in notificacoes['solicitacoesPremium']"
        :key="'sp' + n.id"
        avatar
        @click="openSolicitacaoPremium(n)">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-star</v-icon>
        </v-list-tile-avatar>

        <template>
          <v-list-tile-title
            :title="n.nome_usuario + '('+ n.email_usuario + ') com o telefone ' + n.telefone + ' solicitou um acesso premium de '+ n.qtd_meses + ' meses.'"
            v-text="n.nome_usuario + '('+ n.email_usuario + ') com o telefone ' + n.telefone + ' solicitou um acesso premium de '+ n.qtd_meses + ' meses.'"
          />
        </template>
      </v-list-tile>
      <v-list-tile
        v-for="n in notificacoes['solicitacoesGeraisGestor']"
        :key="'sg_' + n.id"
        avatar

        @click="null">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-domain</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content style="min-width: 70%">
          <template>
            <v-list-tile-title
              v-if="n.nome_criador !== null"
              :title="n.nome_criador + ' solicitou o vinculo de ' + n.nome + '('+ n.email + ') com o telefone ' + n.telefone + ' '"
              v-text="n.nome_criador + ' solicitou o vinculo de ' + n.nome + '('+ n.email + ') com o telefone ' + n.telefone"
            />
            <v-list-tile-title
              v-else
              :title="n.nome + '('+ n.email + ') com o telefone ' + n.telefone + ' solicitou um vinculo '"
              v-text="n.nome + '('+ n.email + ') com o telefone ' + n.telefone + ' solicitou um vinculo '"
            />
            <v-list-tile-sub-title>
              para {{ Cargos[n.acesso].nome }} |
              <v-btn
                color="success"
                small
                @click="aprovarVinculo(n.id_emp_user)">Aprovar</v-btn>
              <v-btn
                color="error"
                flat
                small
                @click="reprovarVinculo(n.id_emp_user)">Reprovar</v-btn></v-list-tile-sub-title>
          </template>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="n in notificacoes['solicitacoesGestor']"
        :key="'sgestor_' + n.id"
        avatar

        @click="null">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-domain</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content style="min-width: 70%">
          <template>
            <v-list-tile-title
              v-if="n.nome_criador !== null"
              :title="n.nome_criador + ' solicitou o vinculo de ' + n.nome + '('+ n.email + ') com o telefone ' + n.telefone + ' '"
              v-text="n.nome_criador + ' solicitou o vinculo de ' + n.nome + '('+ n.email + ') com o telefone ' + n.telefone"
            />
            <v-list-tile-title
              v-else
              :title="n.nome + '('+ n.email + ') com o telefone ' + n.telefone + ' solicitou um vinculo '"
              v-text="n.nome + '('+ n.email + ') com o telefone ' + n.telefone + ' solicitou um vinculo '"
            />
            <v-list-tile-sub-title>
              para {{ Cargos[n.acesso].nome }} |
              <v-btn
                color="success"
                small
                @click="aprovarVinculo(n.id_emp_user)">Aprovar</v-btn>
              <v-btn
                color="error"
                flat
                small
                @click="reprovarVinculo(n.id_emp_user)">Reprovar</v-btn>
            </v-list-tile-sub-title>
          </template>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="notificacoes['alimentosCQBAL'] && notificacoes['alimentosCQBAL'].length > 0"
        avatar
        @click="openCQBAL">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-corn</v-icon>
        </v-list-tile-avatar>
        <template v-if="notificacoes['alimentosCQBAL'] && notificacoes['alimentosCQBAL'].length > 1">
          <v-list-tile-title
            v-text="String(strings[idioma].temos_x_alimentos_cqbal).format(notificacoes['alimentosCQBAL'].length)"
          />
        </template>
        <template v-else-if="notificacoes['alimentosCQBAL'] && notificacoes['alimentosCQBAL'].length === 1">
          <v-list-tile-title
            v-text="String(strings[idioma].tem_um_alimento_cqbal)"
          />
        </template>
      </v-list-tile>
      <v-list-tile
        v-if="notificacoes['alimentos'] && notificacoes['alimentos'].length > 0"
        avatar
        @click="openAlimento">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-corn</v-icon>
        </v-list-tile-avatar>
        <template v-if="notificacoes['alimentos'] && notificacoes['alimentos'].length > 1">
          <v-list-tile-title
            v-text="String(strings[idioma].temos_x_solicitacoes_patrocinio).format(notificacoes['alimentos'].length)"
          />
        </template>
        <template v-else-if="notificacoes['alimentos'] && notificacoes['alimentos'].length === 1">
          <v-list-tile-title
            v-text="String(strings[idioma].tem_uma_solicitacao_patrocinio)"
          />
        </template>
      </v-list-tile>
      <v-list-tile
        v-for="n in notificacoes['dietasCompartilhadas']"
        :key="'dc' + n.id"
        avatar
        @click="n.tipo_dieta === 0 ? openDieta(n) : openPredicao(n)">

        <template v-if="n.tipo_dieta === 0">
          <v-list-tile-avatar>
            <v-icon style="background: #fff;">mdi-silo</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title
            v-if="n.nome_dieta !== '' && n.nome_dieta !== null"
            v-text="strings[idioma].tem_x_dietas_com_nome.format(n.NOME, n.nome_dieta, moment(n.created_at).format(strings[idioma].formato_datas_sem_hora))"
          />
          <v-list-tile-title
            v-else
            v-text="strings[idioma].tem_x_dietas.format(n.NOME, n.email, moment(n.created_at).format(strings[idioma].formato_datas_sem_hora))"
          />
        </template>
        <template v-if="n.tipo_dieta === 1">
          <v-list-tile-avatar>
            <v-icon style="background: #fff;">mdi-chart-line</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title
            v-if="n.nome_dieta !== '' && n.nome_dieta !== null"
            v-text="strings[idioma].tem_x_predicoes_com_nome.format(n.NOME, n.nome_dieta, moment(n.created_at).format(strings[idioma].formato_datas_sem_hora))"
          />
          <v-list-tile-title
            v-else
            v-text="strings[idioma].tem_x_predicoes.format(n.NOME, n.email, moment(n.created_at).format(strings[idioma].formato_datas_sem_hora))"
          />
        </template>
      </v-list-tile>

      <v-list-tile
        v-for="e in notificacoes['empControleUsers']"
        :key="'emp_controle_user' + e.id_empresa + e.id_pessoa"
        avatar
        @click="openEmpControleUser(e)">

        <template v-if="e.ativo === 0">
          <v-list-tile-avatar>
            <v-icon style="background: #fff;">mdi-domain</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title
            v-text="strings[idioma].desvinculado_a_empresa.format(e.nome_usuario, e.nome_empresa, moment(e.updated_at).format(strings[idioma].formato_datas_sem_hora))"
          />
        </template>

        <template v-if="e.ativo === 1">
          <v-list-tile-avatar>
            <v-icon style="background: #fff;">mdi-domain</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title
            v-text="strings[idioma].vinculado_a_empresa.format(e.nome_usuario, e.nome_empresa, moment(e.updated_at).format(strings[idioma].formato_datas_sem_hora))"
          />
        </template>
      </v-list-tile>

      <v-list-tile
        v-for="n in notificacoes['reporteErro']"
        :key="'re' + n.id"
        avatar
        @click="openReporte(n)">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-bug</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title
          v-text="n.descricao"
        />
      </v-list-tile>
      <v-list-tile
        v-for="n in notificacoes['empControle']"
        :key="'ec' + n.id"
        avatar
        @click="openEmpControle(n)">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-domain</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title
          v-text="strings[idioma].empresa_solicitou_mudanca.format(n.nome_empresa)"
        />
      </v-list-tile>
      <v-list-tile
        v-for="n in notificacoes.length > 0 && notificacoes['notificacoesGerais'] !== null && Object.values(notificacoes['notificacoesGerais']).length > 0 ? notificacoes['notificacoesGerais'].filter(n => n.situacao !== 1) : []"
        :key="'ng' + n.id"
        avatar
        @click="openMsg(n)">
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-bell</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title
            v-text="JSON.parse(n['data']).title"
          />
          <v-list-tile-sub-title
            v-text="n['mensagem'] + ' - ' +moment(JSON.parse(n['data']).date).format(strings[idioma].formato_datas_com_hora)"/>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon
            v-if="n['situacao'] == 0"
            color="blue">mdi-eye</v-icon>
          <v-icon
            v-else
            color="grey">mdi-eye</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile
        v-if="notificacoesVazias"
        avatar>
        <v-list-tile-avatar>
          <v-icon style="background: #fff;">mdi-bell</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          {{ strings[idioma].sem_notificacoes }}
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>
<script>
import { createMD5 } from '@/utils/utils'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    notificacoes: {
      type: [Number, String, Array, Object],
      default: () => []
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma']),
    notificacoesVazias () {
      const notificacoes = this.notificacoes
      return notificacoes === null || notificacoes === undefined || Object.values(notificacoes).length === 0 || (notificacoes['alimentosCQBAL'].length === 0 && notificacoes['alimentos'].length === 0 && notificacoes['reporteErro'].length === 0 && notificacoes['dietasCompartilhadas'].length === 0 && notificacoes['users'].length === 0 && notificacoes['empControle'].length === 0 && notificacoes['solicitacoesPremium'].length === 0 && ((notificacoes['notificacoesGerais'] !== null && notificacoes['notificacoesGerais'].length === 0) || notificacoes['notificacoesGerais'] === null))
    },
    Cargos () {
      let cargos = [{
        'nome': this.strings[this.idioma]['empresa_gestor'],
        'nivel': 0,
        'id': 'empresa_gestor'
      },
      {
        'nome': this.strings[this.idioma]['empresa_gerente_regional'],
        'nivel': 1,
        'id': 'empresa_gerente_regional'
      },
      {
        'nome': this.strings[this.idioma]['empresa_tecnico_venda'],
        'nivel': 2,
        'id': 'empresa_tecnico_venda'
      },
      {
        'nome': this.strings[this.idioma]['empresa_produtor_vinculado'],
        'nivel': 3,
        'id': 'empresa_produtor_vinculado'
      }
      ]
      return cargos
    }

  },
  methods: {
    ...mapActions(['setDietaLida']),
    moment (...args) {
      return moment(...args)
    },
    openSolicitacaoPremium (premium) {
      this.axios.post('notificacoes/premiumLido', { id: premium.id, premium }).then(_ => {
        window.location.href = '/adm/solicitacaoPremium?id=' + premium.id
      })
    },

    openDieta (d) {
      let dieta = JSON.parse(d.dieta)
      dieta.id = d.id_dieta
      console.log({ dieta })
      this.setDietaLida(d).then(res => {
        this.$store.commit('loadDieta', dieta.name)
        let comp = {
          id: d.id_compartilhamento,
          id_pessoa: d.id_pessoa,
          pode_compartilhar: d.pode_compartilhar,
          pode_ler: d.pode_ler,
          pode_editar: d.pode_editar,
          id_dieta: d.id_dieta,
          status: d.status
        }
        setTimeout(() => {
          window.location.href = '/formulacao-dieta?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id)) + '&compartilhamentoID=' + d.id_compartilhamento + '&compartilhamento=' + btoa(JSON.stringify(comp)) + '&pessoa=' + d.id_pessoa
        }, 300)
      })
    },
    openPredicao (d) {
      let dieta = JSON.parse(d.dieta)
      dieta.id = d.id_dieta
      this.setDietaLida(d).then(res => {
        this.$store.commit('loadPredicao', dieta.name)
        let comp = {
          id: d.id_compartilhamento,
          id_pessoa: d.id_pessoa,
          pode_compartilhar: d.pode_compartilhar,
          pode_ler: d.pode_ler,
          pode_editar: d.pode_editar,
          id_dieta: d.id_dieta,
          status: d.status
        }

        setTimeout(() => {
          window.location.href = '/predicao-desempenho?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id)) + '&compartilhamento=' + btoa(JSON.stringify(comp)) + '&pessoa=' + d.id_pessoa
        }, 300)
      })
    },
    openReporte (reporte) {
      const url = '/adm/reportes?id=' + reporte.id
      this.axios.post('notificacoes/reporteLido', { id: reporte.id }).then(res => {
        window.location.href = url
      })
    },
    openCQBAL () {
      const url = 'https://cqbal.com.br/#!/pos/alimentosusuarioPendente'
      const win = window.open(url, '_blank')
      this.axios.post('notificacoes/preAlimentoLido').then(res => {
        if (!win || win === null) {
          window.location.href = url
        }
      })
    },
    openAlimento () {
      const url = '/adm?tab=alimentos'
      this.axios.post('notificacoes/alimentoLido').then(res => {
        window.location.href = url
      })
    },
    openUser (ids = null) {
      let url = '/adm?tab=users'
      if (ids !== null) {
        url += '&ids=' + ids.join()
      }
      this.axios.post('notificacoes/userLido').then(res => {
        window.location.href = url
      })
    },
    openEmpControle (empControle) {
      let url = '/adm/empControle'
      this.axios.post('notificacoes/empControleLido', { id: empControle.id }).then(res => {
        window.location.href = url
      })
    },
    openEmpControleUser (EmpControleUser) {
      let url = '/empresa'
      this.axios.post('notificacoes/empControleUserLido', { id: EmpControleUser.id }).then(res => {
        window.location.href = url
      })
    },
    aprovarVinculo (idEmpUser) {
      this.axios.post('empresa/aprovaVinculo', { id_emp_user: idEmpUser }).then(r => {
        window.location.href = '/'
      })
    },
    openMsg (n) {
      this.axios.post('notificacoes_app_set_situacao', { notificacao_id: n.id }).then(res => {
        alert(n.mensagem)
        window.location.href = '/'
      })
    },
    reprovarVinculo (idEmpUser) {
      this.axios.post('empresa/reprovaVinculo', { id_emp_user: idEmpUser }).then(r => {
        window.location.href = '/'
      })
    }
  }
}
</script>
